import { UserUpdateAdapter } from '../../../../adapter';

export default async function UserUpdateUseCase(event) {
    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/user/update';

    const payload = {
        data: {
            userData: {
                ...event
            },
            signature: ''
        }
    };

    // handle request
    const result = await UserUpdateAdapter(requestUrl, JSON.stringify(payload));

    return result;
}
